module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAAWCAYAAAB64jRmAAAAAXNSR0IArs4c6QAAAVRJREFUWEfdl61PA0EQR98PAwqJQCNIkCQoHOEvIHgUCiwCBwkWBFTWU198PbWk+GoIkEAIXwMLe9eWO1padbPrLlmxL2+SeSczqwFLpHuuZGarwA7wnChnLUBOAYfAO2CJgd4CpwpQZrYOrCVo80LSZQY5DRwBjwnZfAJOJL1+Q0abG8Ay8JLIyLYktQJLP+Ts1/cBcJ8A5Fu0GCazBxltbgELQLjk+bQlNTOA3GSEnAf2gDvHhGFDnEm6KYWMoLvAXFwpHlmvJZ33P3zAZIRcBLaBB4+EQF1SdyhkBN0HZoAPZ6BdSfXfby6YjJArwGbcm544G5I6/4X0mHo/CScV0rTUpNPUa0pql43dMEhPqZcn3FiQzlIvT7hJIEPqhd+wKsdBqLNjScFm6flzXLPbZlb11BtIuLFNOki9QsJNBFnx1OtIaoxa5CPHteKpV0i4MuBP1biM2XBQ+A4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/statistic/pai_ming_other.png
// module id = WQer
// module chunks = 2